import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { CarIcon } from '@/assets';
import { LabeledContent } from '@/components/layouts';

import { InfoWindowContentContainer } from '../../Map.styles';
import MarkerWithInfoWindow from '../MarkerWithInfoWindow';

const VehicleMarker = ({ position, make, model, plateState, plate, color }) => {
  const infoWindowContent = useMemo(
    () => (
      <InfoWindowContentContainer>
        {make && <LabeledContent content={make} label="Make" />}
        {model && <LabeledContent content={model} label="Model" />}
        {plate && (
          <LabeledContent
            content={`${plateState ? `${plateState} ` : ''}${plate}`}
            label="License Plate"
          />
        )}
        {color && <LabeledContent content={color} label="Color" />}
      </InfoWindowContentContainer>
    ),
    [make, model, plateState, plate, color],
  );

  return (
    <MarkerWithInfoWindow
      position={position}
      infoWindowContent={infoWindowContent}
    >
      <CarIcon
        sx={{
          transition: 'transform 250ms ease-in-out, rotate 250ms ease-in-out',
        }}
      />
    </MarkerWithInfoWindow>
  );
};

VehicleMarker.propTypes = {
  position: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
  make: PropTypes.string,
  model: PropTypes.string,
  plateState: PropTypes.string,
  plate: PropTypes.string,
  color: PropTypes.string,
};

export default VehicleMarker;
